/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class SuperuserOutcomeCreditConfigsService {

  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * List the effective outcome credit config for every managed outcome type for a company (superuser only)
   * @param companyUuid UUID of the company
   * @returns any Outcome credit configs retrieved successfully
   * @throws ApiError
   */
  public getApiServiceorganizationsProcessesSuperuserOutcomeCreditConfigs(
    companyUuid: string,
  ): CancelablePromise<{
    data?: {
      configs?: Array<{
        outcomeType?: string;
        creditsCost?: number;
        disputable?: boolean;
        /**
         * True when a per-company record exists; false when using the hardcoded default
         */
        isOverride?: boolean;
      }>;
    };
  }> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/serviceorganizations/processes/superuser/outcomeCreditConfigs/{companyUuid}',
      path: {
        'companyUuid': companyUuid,
      },
      errors: {
        403: `Forbidden - superuser role required`,
        500: `Internal server error`,
      },
    });
  }

  /**
   * Create or update the outcome credit config override for a company (superuser only)
   * @param companyUuid UUID of the company
   * @param outcomeType Managed outcome type (e.g. anna_interview)
   * @param requestBody
   * @returns any Outcome credit config upserted successfully
   * @throws ApiError
   */
  public patchApiServiceorganizationsProcessesSuperuserOutcomeCreditConfigs(
    companyUuid: string,
    outcomeType: string,
    requestBody: {
      /**
       * Number of credits deducted per occurrence of this outcome type for this company
       */
      creditsCost: number;
      /**
       * Whether billing events emitted for this outcome type may be disputed
       */
      disputable: boolean;
    },
  ): CancelablePromise<{
    data?: {
      /**
       * The upserted outcome credit config
       */
      config?: Record<string, any>;
    };
  }> {
    return this.httpRequest.request({
      method: 'PATCH',
      url: '/api/serviceorganizations/processes/superuser/outcomeCreditConfigs/{companyUuid}/{outcomeType}',
      path: {
        'companyUuid': companyUuid,
        'outcomeType': outcomeType,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad request - validation error or unsupported outcome type`,
        403: `Forbidden - superuser role required`,
        500: `Internal server error`,
      },
    });
  }

}
